<template>

    <div class="menu-con d-flex flex-column" :class="{'menu-close':menuState=='close'}">
      <vue-custom-scrollbar class="nav-con h-100 grmb-8 text-secondary">
<!-- 
        <div class="grml-8 grpt-8 grpb-8 my-auto text-white">
          <small class="l-s-2">MENU</small>
        </div> -->

        <div>
          <b-nav vertical class="w-100 vertical-nav">

            <menu-component></menu-component> 

          </b-nav>
        </div>
      </vue-custom-scrollbar>

      <div class="grm-8 support-con mt-auto">
       <router-link :to="{name:'support'}" tag="button" class="btn btn-block btn-support btn-sm grh-9" >
         <i class="lni lni-headphone-alt"></i> Support Contact
        </router-link>
      </div>
    </div>
 
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar"
import menuComponent from '@/layouts/partials/TheAppMenu'

export default {
  components: {
    vueCustomScrollbar,
    menuComponent
  },
  computed: {
    menuState () {
      return this.$store.getters['menu/menuState']
    }
  },
  data(){
    return{
    }
  },
  methods:{
   
  }
};
</script>

<style lang="scss" scoped>

.menu-con {
  z-index: 100;
  position: fixed;
  width: 236px;  
  top: 49px;
  bottom: 7px;
  padding-top: 93px;
  left: 10px;
  background-color: var(--primary);
  overflow: hidden;
  transition: all 0.3s ease;
  border-bottom-left-radius: 22px;
  border-bottom-right-radius: 22px;
  border-top-right-radius: 64px;

}
.menu-close{
  width:0;
}

.btn-support{
  background: var(--primaryLighter);
  color: #FFF;
}
</style>